<div class="h-full flex flex-col justify-start items-center overflow-hidden">
    <div class="w-full flex flex-col flex-1 min-h-0">
        <div class="sm:flex sm:items-center shrink-0">
            <div class="sm:flex-auto">
                <h1 class="text-base font-semibold text-primary">Brand Users</h1>
                <p class="mt-2 text-sm text-secondary">A list of all the users with aceess to this brand account.</p>
            </div>
            <div class="mt-4 sm:mt-0 sm:ml-16 sm:flex-none mr-2">
                <button type="button" (click)="showAddUserDrawer.set(true)"
                    class="block rounded-md bg-primary px-3 py-2 text-center text-sm font-semibold text-white shadow-xs hover:bg-primary/85 focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-primary">Add
                    user</button>
            </div>
        </div>
        @if (allCompanyUsers() && allCompanyUsers()!.length > 0) {   
        <div class="mt-8 flex flex-col overflow-hidden border border-zinc-200 dark:border-zinc-800 rounded-lg flex-1 min-h-0">
            <div class="overflow-y-auto flex-1 scrollbar-transparent">
                <table class="min-w-full divide-y divide-zinc-200 dark:divide-zinc-800">
                    <thead class="bg-zinc-50 dark:bg-zinc-900/50 sticky top-0 z-10">
                        <tr>
                            <th scope="col"
                                class="py-3.5 pr-3 pl-4 text-left text-sm font-semibold text-primary sm:pl-6">Name
                            </th>
                            <th scope="col" class="px-3 py-3.5 text-left text-sm font-semibold text-primary">Title
                            </th>
                            <th scope="col" class="px-3 py-3.5 text-left text-sm font-semibold text-primary">Status
                            </th>
                            <th scope="col" class="px-3 py-3.5 text-left text-sm font-semibold text-primary">Role</th>
                        </tr>
                    </thead>
                    <tbody class="bg-white dark:bg-zinc-900 divide-y divide-white/10">
                        @for (user of allCompanyUsers()!; track user.id) {
                        <tr>
                            <td class="py-5 pr-3 pl-4 text-sm whitespace-nowrap sm:pl-6">
                                <div class="flex items-center">
                                    <div class="size-11 shrink-0">
                                        <img [src]="imageService.getImageSource(user.userAccount.photoURL, 'gallery')"
                                            alt="" class="size-11 rounded-full outline outline-white/10" />
                                    </div>
                                    <div class="ml-4">
                                        <div class="font-medium text-primary">{{ user.userAccount.firstName }} {{
                                            user.userAccount.lastName }}</div>
                                        <div class="mt-1 text-secondary">{{ user.userAccount.email }}</div>
                                    </div>
                                </div>
                            </td>
                            <td class="px-3 py-5 text-sm whitespace-nowrap text-secondary">
                                <div class="text-primary">{{ user.userAccount.jobPosition || "Unknown" }}</div>
                            </td>
                            <td class="px-3 py-5 text-sm whitespace-nowrap text-secondary">
                                <span class="inline-flex items-center rounded-md px-2 py-1 text-xs font-medium ring-1 ring-inset" [class]="accountStatusStyle(user)">{{ getAccountStatus(user)}}</span>
                            </td>
                            <td class="px-3 py-5 text-sm whitespace-nowrap text-secondary">{{ getRoleName(user.businessAccountRole) }}</td>
                        </tr>
                        }
                    </tbody>
                </table>
            </div>
        </div>
        } @else {
            no users.
        }
    </div>

</div>

@if (showAddUserDrawer()) {
<mb-brand-team-add-user mode="brand" [brandId]="focussedBrandId()"
    (close)="showAddUserDrawer.set(false)" (confirmEvent)="refreshUserList()"></mb-brand-team-add-user>
}